import {get, post, postJson} from './axios'

// 获取时间段内的催付信息

const RESOURCE_BASE_PATH = '/notpayremind'

export const getRemindByTime = p => postJson(`${RESOURCE_BASE_PATH}/getRemindByTime`, p);
